import React, { useState, useEffect } from 'react';
import styles from './CommentModal.module.css';
import RollbackIcon from '../../Icon/RollbackIcon';
import { Modal, Textarea, ActionIcon } from '@mantine/core';
import { useMantineTheme } from '@mantine/core';

const CommentModal = ({ isOpen, onClose, onRollback, comment, onCommentChange, hasPreviousComment }) => {
    const [newComment, setNewComment] = useState('');
    const theme = useMantineTheme();

    useEffect(() => {
        // Loại bỏ khoảng trắng và dòng trống ở đầu/cuối
        setNewComment(comment ? comment.trim() : '');
    }, [comment]);

    if (!isOpen) return null;

    const handleCommentChange = (e) => {
        setNewComment(e.target.value);
    };

    const handleSaveAndClose = () => {
        const trimmedComment = newComment.trim();
        if (trimmedComment !== comment) {
            onCommentChange(trimmedComment);
        }
        onClose(trimmedComment);
    };

    const handleSave = () => {
        const trimmedComment = newComment.trim();
        if (trimmedComment !== comment) {
            onCommentChange(trimmedComment);
        }
    };

    const handleRollbackClick = (e) => {
        e.stopPropagation();
        onRollback();
        handleSave();
    };

    const handleTextareaMouseDown = (e) => {
        e.stopPropagation();
    };

    const handleTextareaSelectStart = (e) => {
        e.stopPropagation();
    };

    const handleKeyDown = (e) => {
        if (e.ctrlKey && e.key === 'v') {
            e.stopPropagation();
        }
    };

    const handlePaste = (e) => {
        e.stopPropagation();
    };

    return (
        <Modal
            opened={isOpen}
            onClose={handleSaveAndClose}
            onDoubleClick={(e) => e.stopPropagation()}
            title={
                <div className={styles.modalHeader}>
                    <span className={styles.modalTitle}>Add comment</span>
                    <div className={styles.modalButtons}>
                        <ActionIcon
                            onClick={handleRollbackClick}
                            disabled={!hasPreviousComment}
                            onDoubleClick={(e) => e.stopPropagation()}
                            title="Rollback to previous comment"
                            size="md"
                            variant="subtle"
                            color="gray"
                            className={`${styles.rollbackButton} ${!hasPreviousComment ? styles.disabled : ''}`}
                        >
                            <RollbackIcon style={{ fontSize: '20px' }} />
                        </ActionIcon>
                    </div>
                </div>
            }
            size="sm"
            styles={{
                root: {
                    '.mantine-Modal-modal': {
                        padding: '0 !important'
                    },
                    '.mantine-17leyt0': {
                        marginRight: '0 !important',
                        borderBottom: '2px solid #0291F166'
                    }
                },
                header: {
                    padding: '16px 20px',
                    marginBottom: 0,
                    borderBottom: '1px solid #eee',
                },
                title: {
                    width: '100%',
                    margin: 0,
                },
                close: {
                    color: theme.colorScheme === 'dark' ? theme.colors.gray[0] : theme.colors.gray[7],
                    '&:hover': {
                        backgroundColor: 'transparent',

                    },
                },
                body: {
                    padding: '0',
                },
            }}
        >
            <div
                className={styles.modalContentWrapper}
                onKeyDown={handleKeyDown}
                onPaste={handlePaste}
            >
                <Textarea
                    value={newComment}
                    onChange={handleCommentChange}
                    placeholder="Write a comment..."
                    autosize
                    minRows={4}
                    maxRows={8}
                    maxLength={255}
                    onDoubleClick={(e) => e.stopPropagation()}
                    onMouseDown={handleTextareaMouseDown}
                    onSelectStart={handleTextareaSelectStart}
                    onBlur={handleSave}
                    onKeyDown={handleKeyDown}
                    onPaste={handlePaste}
                    className={styles.commentInput}
                    styles={{
                        root: {
                            padding: '16px 20px',
                        },
                        input: {
                            userSelect: 'text',
                            backgroundColor: 'transparent',
                            color: theme.colorScheme === 'dark' ? '#fff' : '#000',
                            border: 'none',
                            padding: '0',
                            fontSize: '14px',
                            lineHeight: '1.5',
                            '&:focus': {
                                border: 'none',
                                outline: 'none',
                            },
                            '&::placeholder': {
                                color: theme.colorScheme === 'dark' ? '#fff' : '#000',
                            },
                        },
                    }}
                />
                <div className={`${styles.characterCounter} ${newComment.length >= 255 ? styles.error : ''}`}>
                    {newComment.length}/255 characters
                </div>
            </div>
        </Modal>
    );
};

export default CommentModal;